/**
 * The responsibility of this file is to render single list item for the menu list.
 * It is reusable component to make sidebar menu list item.
 */

import * as React from 'react';
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';

export default function ListItem({
    url,
    onSelect,
    isSelected = false,
    tabName = 'Dashboard',
    icon = <DashboardIcon />,
    shouldEnabledMenu = false
}) {
    return (
        <List
            sx={{ width: '100%', maxWidth: 280, padding: 0 }}
            component="nav"
            aria-labelledby="listItem"
        >
            <Link
                to={url}
                onClick={onSelect}
                style={{ pointerEvents: shouldEnabledMenu ? 'none' : 'auto' }}
            >
                <ListItemButton
                    selected={isSelected}
                    variant="dashboardListItem"
                    disableRipple
                    disabled={shouldEnabledMenu}
                >
                    {/* set the icon color conditionally if menu is selected */}
                    <ListItemIcon>
                        {React.cloneElement(icon, {
                            color: isSelected ? 'secondary' : 'inherit'
                        })}
                    </ListItemIcon>
                    <ListItemText primary={tabName} />
                </ListItemButton>
            </Link>
        </List>
    );
}
